import { useState, useEffect, useMemo, useLayoutEffect } from "react";
import { GrAscend, GrDescend } from "react-icons/gr";
import { PiMagnifyingGlass, PiPlugs, PiPlugsConnected } from "react-icons/pi";
import { SiGmail } from "react-icons/si";
import ItemsLoader from "../Loaders/ItemsLoading";
import { TbReload } from "react-icons/tb";
import { BiError, BiPlus } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import McpBuilderTypeModal from "./McpBuilderTypeModal";
import ConnectCustomMcpModal from "./CustomMcps/ConnectCustomMcpModal";
import DisconnectCustomMcpModal from "./CustomMcps/DisconnectCustomMcpModal";
import ErrorDeploymentModal from "./ErrorDeploymentModal";
import { DiNodejs, DiPython } from "react-icons/di";
import { FaNodeJs } from "react-icons/fa";
import MandatorySign from "../Components/MandatorySign";
import { ImNewTab } from "react-icons/im";
import ConnectOauthModal from "./Oauth/ConnectOauthModal";
import DisconnectOatuhModal from "./Oauth/DisconnectOauthModal";
import { LuTrash2 } from "react-icons/lu";
import { VscSettingsGear } from "react-icons/vsc";
import ConfirmDeleteMcpModal from "./ConfirmDeleteMcpModal";
import { useLanguage } from "../Translations/LenguageContext";

const MainMcps = ({
    account_id,
    userData,
    setMcpData,
    mcpData,
    fetchMcpData,
    loadingMcpData
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const { org_id } = useParams()
    const [selectedMCP, setSelectedMcp] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [showConnectMcpModal, setShowConnectMcpModal] = useState(false)
    const [showDisconnectMcpModal, setShowDisconnectMcpModal] = useState(false)
    const [showTypeMcpModal, setShowTypeMcpModal] = useState(false)
    const [openCustomModal, setOpenCustomModal] = useState(false)
    const [showCustomDisconnectModal, setShowCustomDisconnectModal] = useState(false)
    const [openErrDepModal, setOpenErrDepModal] = useState(false)
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false)
    const [popupMex, setPopupMex] = useState({ active: false, type: null, message: "" })
    const [selectedMcpId, setSelectedMcpId] = useState(null)

    const filteredAndSortedData = useMemo(() => {
        if (!mcpData) return [];

        let result = mcpData.filter((org) => {
            const term = searchTerm.toLowerCase();
            const nameMatch = org.name?.toLowerCase().includes(term);
            const descMatch = org.description?.toLowerCase().includes(term);

            const memberMatch = org.members?.some(m =>
                m.name?.toLowerCase().includes(term) ||
                m.surname?.toLowerCase().includes(term) ||
                m.email?.toLowerCase().includes(term)
            );

            return nameMatch || descMatch || memberMatch;
        });

        result.sort((a, b) => {
            const nameA = a.name?.toLowerCase() || "";
            const nameB = b.name?.toLowerCase() || "";
            if (sortOrder === "asc") {
                return nameA.localeCompare(nameB);
            } else {
                return nameB.localeCompare(nameA);
            }
        });

        return result;
    }, [mcpData, searchTerm, sortOrder]);


    const handleNavigate = (runtime, mcp_id, custom, version_n) => {
        if (custom) {
            const mainUrl = `/e8console/organizations/${org_id}/abilities`;

            let targetPath = "";

            targetPath =
                runtime === "python"
                    ? `${mainUrl}/ability-builder/python/${mcp_id}/${version_n}`
                    : `${mainUrl}/ability-builder/javascript/${mcp_id}/${version_n}`;

            navigate(targetPath);
        }
    };

    const handleDelete = (item) => {
        setOpenConfirmDeleteModal(true)
        setSelectedMcpId(item)
    }

    useEffect(() => {
        fetchMcpData(org_id)
    }, [account_id]);

    const handleOpenConnect = (system_provider) => {
        system_provider != "Project E8" ? setShowConnectMcpModal(true) : setOpenCustomModal(true)
    }

    const handleOpenDisconnect = (system_provider) => {
        system_provider != "Project E8" ? setShowDisconnectMcpModal(true) : setShowCustomDisconnectModal(true)
    }

    if (loadingMcpData) {
        return <ItemsLoader />
    }

    return (
        <div className="mainframe_item">
            <div className="mainframe_item_header" >
                <p className="mainframe_item_title fade-in">{t.abilities.title}</p>
                <div className="mainframe_item_subtitle fade-in">
                    {mcpData.length === 0 ? (
                        <div className="empty_org_mex_cont">
                            <p>{t.abilities.empty_subtitle}</p>
                            <div className="empty_org_img">
                                <p className="empty_org_img_title">
                                    <i><PiPlugs /></i> {t.abilities.quest_title}
                                </p>
                                <p className="empty_org_img_subtitle">
                                    {t.abilities.quest_answ}
                                </p>
                                <a
                                    href="/directories/abilities"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="sidebar_message_btn"
                                >
                                    <span><ImNewTab /> {t.open_directory}</span>
                                </a>
                            </div>
                        </div>
                    ) : (
                        <p>{t.abilities.subtitle}</p>
                    )}
                </div>

                <button
                    className={`mainframe_item_create_btn fade-in ${mcpData.length === 0 && "mainframe_item_create_btn_anim"}`}
                    onClick={() => setShowTypeMcpModal(true)}
                >
                    <BiPlus /> {t.create}
                </button>


            </div>


            {mcpData.length > 0 && (
                <div className="filter_body_mainframe">
                    <div className="filtering_mainframe">
                        <div className="filtering_mainframe_btn_cont fade-in">
                            <a
                                href="/directories/abilities"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="filter_btn_a"
                            >
                                <span><ImNewTab /> {t.open_directory}</span>
                            </a>
                            {mcpData.length > 1 && (
                                <>
                                    <button
                                        className={`filter_btn ${sortOrder === "asc" ? "active" : ""}`}
                                        onClick={() => setSortOrder("asc")} title="A-Z"
                                    >
                                        <GrAscend />
                                    </button>
                                    <button
                                        className={`filter_btn ${sortOrder === "desc" ? "active" : ""}`}
                                        onClick={() => setSortOrder("desc")}
                                        title="Z-A"
                                    >
                                        <GrDescend />
                                    </button>
                                </>
                            )}
                            <button
                                className="filter_btn"
                                onClick={() => fetchMcpData(org_id)}
                                title={t.reload}
                            >
                                <TbReload />
                            </button>
                        </div>
                        <div className="filter_input_cont fade-in">
                            <input
                                className="filter_input"
                                placeholder={t.search_filter}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <span className="filter_input_icon"><PiMagnifyingGlass /></span>
                        </div>
                    </div>

                    <div className="organizations_cont">
                        <div className="organizations_cont_inner">
                            {filteredAndSortedData.length === 0 ? (
                                <div className="organizations_cont_no_items_mex fade-in">
                                    <p>{t.no_data_found}</p>
                                </div>
                            ) : (
                                filteredAndSortedData.map((mcp) => (
                                    <div
                                        key={mcp.id}
                                        className={`model_item fade-in ${mcp.custom ? "" : "model_item_no_drop"} ${mcp.status_deployment == "DEPLOYING" && "model_item_deploying"}`}
                                        onClick={() => handleNavigate(mcp.runtime, mcp.id, mcp.custom, mcp.drafted_version)}
                                    >
                                        <div className="model_name">
                                            <p>
                                                {mcp.custom && (
                                                    mcp.runtime == "python" ? (
                                                        <i><DiPython /></i>
                                                    ) : (
                                                        <i><FaNodeJs /></i>
                                                    )
                                                )}
                                                {mcp.name}
                                                {mcp.tag && (
                                                    <span className="model_name_tag">{mcp.tag}</span>
                                                )}
                                            </p>
                                            <span className="model_name_tag_span">

                                                {mcp.is_version_different && (
                                                    <span className="version_alert" onClick={(e) => e.stopPropagation()}>
                                                        <MandatorySign message={"The deployed version and your connected version differ. We recommend reconnecting to sync them."} icon="info" />
                                                    </span>
                                                )}
                                                {!mcp.custom ? (
                                                    <span className="model_item_public" >
                                                        {t.public}
                                                    </span>
                                                ) : (
                                                    <span className="model_item_custom" >
                                                        {t.custom}
                                                    </span>
                                                )}
                                                {mcp.status_deployment == "DEPLOYED"  && (
                                                    <button className="filetree_editor_header_btn fade-in" onClick={(e) => {e.stopPropagation(); handleDelete(mcp.id)}}> <LuTrash2 /></button>
                                                )}
                                            </span>
                                        </div>

                                        <div className="model_description" title={mcp.description}>
                                            {mcp.description}
                                        </div>


                                        <div className="model_tags">
                                            <div className="model_tags_cont">
                                                {mcp.category && (
                                                    <>
                                                        {mcp.category.slice(0, 1).map((cat, index) => (
                                                            <span key={index} className="model_tag_item" title={cat}>
                                                                {cat}
                                                            </span>
                                                        ))}

                                                        {mcp.category.length > 1 && (
                                                            <span className="model_tag_more">
                                                                +{mcp.category.length - 1}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            </div>

                                            {mcp.is_connected ? (
                                                <button
                                                    className="activate_mcp_btn_active"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedMcp(mcp);
                                                        handleOpenDisconnect(mcp.system_provider);
                                                    }}
                                                >
                                                    {t.disconnect} <PiPlugs />
                                                </button>
                                            ) : (
                                                mcp.status_deployment == "DEPLOYING" ? (
                                                    <button
                                                        className="activate_mcp_btn_active"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            fetchMcpData(org_id)
                                                        }}

                                                    >
                                                        <TbReload />
                                                    </button>
                                                ) : mcp.status_deployment != "DEPLOYED" ? (
                                                    <button
                                                        className="activate_mcp_btn_active"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setOpenErrDepModal(true)
                                                        }}

                                                    >
                                                        <BiError />
                                                    </button>
                                                ) : (
                                                    mcp.version && (

                                                        <button
                                                            className="activate_mcp_btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedMcp(mcp);
                                                                handleOpenConnect(mcp.system_provider)
                                                            }}
                                                        >
                                                            {t.connect} <PiPlugsConnected />
                                                        </button>
                                                    )
                                                )
                                            )}
                                        </div>
                                    </div>
                                ))
                            )}

                        </div>
                    </div>
                </div>
            )}

            <McpBuilderTypeModal
                account_id={account_id}
                show={showTypeMcpModal}
                handleClose={() => setShowTypeMcpModal(false)}
            />

            <ConnectOauthModal
                account_id={account_id}
                userData={userData}
                show={showConnectMcpModal}
                handleClose={() => setShowConnectMcpModal(false)}
                selectedMCP={selectedMCP}
                setMcpData={setMcpData}
            />

            <ConnectCustomMcpModal
                account_id={account_id}
                userData={userData}
                show={openCustomModal}
                handleClose={() => setOpenCustomModal(false)}
                selectedMCP={selectedMCP}
                fetchData={fetchMcpData}
                setMcpData={setMcpData}
            />

            <DisconnectOatuhModal
                account_id={account_id}
                userData={userData}
                show={showDisconnectMcpModal}
                handleClose={() => setShowDisconnectMcpModal(false)}
                selectedMCP={selectedMCP}
                fetchData={fetchMcpData}
            />

            <DisconnectCustomMcpModal
                account_id={account_id}
                userData={userData}
                show={showCustomDisconnectModal}
                handleClose={() => setShowCustomDisconnectModal(false)}
                selectedMCP={selectedMCP}
                fetchData={fetchMcpData}
            />

            <ErrorDeploymentModal
                show={openErrDepModal}
                handleClose={() => setOpenErrDepModal(false)}
            />

            <ConfirmDeleteMcpModal
                setPopupMex={setPopupMex}
                account_id={account_id}
                show={openConfirmDeleteModal}
                handleClose={() => setOpenConfirmDeleteModal(false)}
                org_id={org_id}
                mcp_id={selectedMcpId}
                fetchData={fetchMcpData}
            />
        </div>
    );
};

export default MainMcps;